<form [formGroup]="kratosForm">
  <!-- parent-provided layout and templates -->
  <ng-content></ng-content>

  <!-- where fallback fields (if any) will be injected -->
  <div class="flex flex-col gap-4 empty:hidden">
    <ng-container #fallbackHost></ng-container>
  </div>
</form>
